export const version = "properties/5.0.4";
//# sourceMappingURL=_version.js.map